var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 17.833V6.167c0-.322.11-.597.33-.825.22-.228.484-.342.795-.342h6.504c.164 0 .327.062.488.187a.889.889 0 0 1 .32.442L12 7.333h7.875c.31 0 .576.114.795.342.22.228.33.503.33.825v9.333c0 .322-.11.597-.33.825-.22.228-.484.342-.795.342H4.125c-.31 0-.576-.114-.795-.342a1.145 1.145 0 0 1-.33-.825z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7cef7ea0c4c9eab18eadb233b560a2ca.svg";
export { ForwardRef as ReactComponent };